import { observable, runInAction } from 'mobx';
import { get } from '../utils';

class Logistics {
    private route: string;
    private params: any;
    @observable
    public logisticsData: any;

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    async fetch(callback?, errs?) {
        get(this.route, this.params).then((d) => {
            let data: any;
            if (d.errCode != 200) {
                errs && errs(d.errCode);
                return;
            } else {
                if (d.data) {
                    data = d.data;
                    runInAction(() => {
                        this.logisticsData = data;
                        callback && (this.logisticsData = callback(data));
                    });
                } else {
                    callback && callback({});
                }
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }
}

export default Logistics;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/logistics.ts